var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0V20H16V13H12V6C12 2.68629 14.6863 0 18 0ZM16 2.53C15.17 3 14 4.17 14 6V11H16V2.53ZM6 11.9V20H4V11.9C1.71776 11.4367 0 9.419 0 7V1H2V8H4V1H6V8H8V1H10V7C10 9.419 8.2822 11.4367 6 11.9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuimage);
export default __webpack_public_path__ + "static/media/menuimage.3b22681dfd474a771c37d5c454e397c8.svg";
export { ForwardRef as ReactComponent };